import GateVertex from '../GateVertex';
import ATLEASTGateVertexValue from "./ATLEASTGateVertexValue";

class ATLEASTGateVertex extends GateVertex {
  constructor(key: string, value: ATLEASTGateVertexValue) {
    super(key, value);
  }

  clone(): ATLEASTGateVertex {
    return new ATLEASTGateVertex(null, this.value.clone());
  }
}

export default ATLEASTGateVertex;
